import {nextTick} from "vue";
import gsap from "gsap";
import {getScrollValue} from "@km/mixins/scrollvalue";

export function scrollToActivePatternOrCategoryAfterRepaint(containerClass) {
    nextTick().then(() => {
        gsap.to("." + containerClass, {
            duration: 0.4,
            scrollLeft: getScrollValue("."+containerClass + ' .active')
        })
    })
}